import {
  type ApiResponse,
  type PaginatedResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  CreateCampaignInput,
  UpdateCampaignInput,
  Campaign,
  CampaignProgress,
  CampaignStatus
} from './types/campaigns.types';

export interface ListCampaignsParams {
  status?: CampaignStatus
  limit?: number
  offset?: number
}

/** Admin only. */
export async function listCampaigns(
  params: ListCampaignsParams = {},
  token: string
): Promise<PaginatedResponse<Campaign>> {

  const query = new URLSearchParams();

  if (params.status !== undefined) {

    query.set('status', params.status);
  }

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<PaginatedResponse<Campaign>>(`/campaigns${ qs }`, undefined, token);
}

/** Admin only. */
export async function createCampaign(
  input: CreateCampaignInput,
  token: string
): Promise<ApiResponse<Campaign>> {

  return apiRequest<ApiResponse<Campaign>>(
    '/campaigns',
    {
      method: 'POST',
      body: JSON.stringify(input)
    },
    token
  );
}

/** Admin only. */
export async function updateCampaign(
  id: number,
  input: UpdateCampaignInput,
  token: string
): Promise<ApiResponse<Campaign>> {

  return apiRequest<ApiResponse<Campaign>>(
    `/campaigns/${ id }`,
    {
      method: 'PUT',
      body: JSON.stringify(input)
    },
    token
  );
}

/** Admin only. */
export async function getCampaignById(
  id: number,
  token: string
): Promise<ApiResponse<Campaign>> {

  return apiRequest<ApiResponse<Campaign>>(`/campaigns/${ id }`, undefined, token);
}

/** Public - no auth. Returns the campaign plus its live raised total. */
export async function getCampaignByKey(
  campaignKey: string
): Promise<ApiResponse<CampaignProgress>> {

  return apiRequest<ApiResponse<CampaignProgress>>(`/campaigns/by-key/${ campaignKey }`);
}
